import axios from "axios";

export const postEmailTribalSupport = async (summary: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/Email/tribal-support`,
      { summary: summary }
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
